module.exports = __webpack_public_path__ + "img/Cookie_1_resize_38.8c977f9a.png";